import $ from 'jquery';

$(function () {

	let slider = null;

	function initSlider() {
		if(slider === null && $('.top-menu-picks-slider').length > 0) {
			$('.top-menu-picks-slider').removeClass('row');
			slider = tns({
				container: '.top-menu-picks-slider',
				items: 1.1,
				mouseDrag: true,
				preventScrollOnTouch: 'force',
				edgePadding: 20,
				// slideBy: 'page',
				gutter: 20,
				controls: false,
				navPosition: 'bottom',
				autoplay: false,
				center: true,
				// autoplay: true,
				// controlsContainer: ".controls",
				// navContainer: ".tns-nav",
				// autoplayButtonOutput: true
			});
		}
	}

	function destroySlider() {
		if(slider !== null)  {
			slider.destroy();
			slider = null;
			$('.top-menu-picks-slider').addClass('row');
		}
	}

	function main() {
		if(window.innerWidth < 992) {
			initSlider();
		} else {
			destroySlider();
		}
	}

	main();

	$(window).on('resize', (evt) => {
		main();
	});

});
